import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { AnalyticsEvent } from '@hdms/shared/common-types';
import { OauthService, UserContextService } from '@hdms/shared/data-access';
import { ButtonBaseClassesType, ButtonModule, IconsName, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule, EnvironmentService } from '@hdms/shared/util-core';

@Component({
  standalone: true,
  selector: 'shrd-ft-login-button',
  templateUrl: './login-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, ButtonModule, SvgIconModule, AsyncPipe, NgClass, AnalyticsModule]
})
export class LoginButtonComponent {
  @Input() text: string;
  @Input() icon: IconsName;
  @Input() variant: ButtonBaseClassesType;
  @Input() trackEvent: AnalyticsEvent;
  @Input() additionalClasses: string;

  @Output() clickHandler = new EventEmitter<void>();

  readonly isLoggedIn = inject(UserContextService).isLoggedIn;
  readonly inHostContext = !!inject(EnvironmentService).hostContext;
  readonly loginUrl$ = inject(OauthService).getLoginUrl$();
}
